<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <div class="col-12">
                    <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('name')">
                            <b-form-input :validate-error="errors[0]" v-model="form.name">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="subject" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('subject')">
                            <b-form-input :validate-error="errors[0]" v-model="form.subject">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="code" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('code')">
                            <b-form-input :validate-error="errors[0]" v-model="form.code">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="recipients" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('recipients')">
                            <b-form-input :validate-error="errors[0]" v-model="form.recipients">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="body" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('body')">
                            <CkEditor v-model="form.body"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>

            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="updateForm" type="button" variant="primary" class="btn-lg mr-2">
                {{ $t("save").toUpperCase() }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Component
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import CkEditor from "@/components/interactive-fields/Ckeditor.vue";
    import EmailTemplateServices from "@/services/EmailTemplateServices";

    export default {
        components: {
            CkEditor,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                form: {
                    subject: null,
                    recipients: null,
                    code: null,
                    name: null,
                    body: null,
                }
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
         created() {
             this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                EmailTemplateServices.show(id)
                                      .then((response) => {
                                          this.form = response.data.data;
                                          this.formLoading = false;
                                      })
                                      .catch((error) => {
                                          if (error.data.message) {
                                              this.$toast.error(this.$t("api." + error.data.message));
                                          }
                                      })
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;
                    EmailTemplateServices.update(this.formId, this.form)
                                          .then((response) => {
                                              this.$toast.success(this.$t("api." + response.data.message));
                                              this.$emit("updateFormSuccess")
                                          })
                                          .catch((error) => {
                                              this.showErrors(error, this.$refs.formModalValidate)
                                          }).finally(() => {
                        this.formLoading = false;
                    })
                }
            }
        }
    }
</script>
